import { motion } from "framer-motion";

export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const EASE = [0.2, 0.8, 0.2, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.06, ease: EASE },
  }),
};

export function Eyebrow({ children, className = "" }) {
  return (
    <span
      className={`font-mono-tech text-[11px] uppercase tracking-[0.18em] text-emerald-700 ${className}`}
    >
      {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, intro, align = "left", testid }) {
  const alignCls = align === "center" ? "mx-auto text-center" : "";
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={fadeUp}
      className={`max-w-3xl ${alignCls}`}
    >
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <h2
        data-testid={testid}
        className="mt-4 text-2xl font-semibold leading-tight tracking-[-0.03em] text-[color:var(--text-primary)] sm:text-3xl lg:text-4xl"
      >
        {title}
      </h2>
      {intro ? (
        <p className="mt-5 text-base leading-relaxed text-secondary md:text-lg">
          {intro}
        </p>
      ) : null}
    </motion.div>
  );
}

export function Chip({ children }) {
  return (
    <span className="inline-flex items-center rounded-full border border-black/10 bg-white px-3 py-1 font-mono-tech text-[11px] text-secondary">
      {children}
    </span>
  );
}

export function Screenshot({ src, alt, caption, className = "" }) {
  return (
    <figure
      className={`overflow-hidden rounded-[16px] border border-black/10 bg-[var(--ink-900)] ${className}`}
    >
      <div className="flex items-center gap-1.5 border-b border-black/[0.08] px-3 py-2">
        <span className="h-2.5 w-2.5 rounded-full bg-black/20" />
        <span className="h-2.5 w-2.5 rounded-full bg-black/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-black/10" />
      </div>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="block h-auto w-full"
      />
      {caption ? (
        <figcaption className="border-t border-black/[0.08] px-4 py-2.5 text-xs text-tertiary">
          {caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
